import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './CloseButton.module.scss';

export interface CloseButtonProps {
  label?: string;
  onClick: () => void;
}

export const CloseButton = ({ label, onClick }: CloseButtonProps) => {
  const { t } = useTranslation('news');

  return (
    <Button
      className={styles.styledButton}
      data-testid="close-button"
      label={label ?? t('news:searchBar.closeButtonLabel')}
      onClick={onClick}
      variant="empty"
      size="small"
    />
  );
};
